var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarDinero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 58.674,
    viewBox: "0 0 64 58.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_682",
    "data-name": "Grupo 682",
    transform: "translate(-464.987 -2637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(464.987 2637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_259",
    "data-name": "Trazado 259",
    d: "M378.924,543.674a8.038,8.038,0,0,0-4.854-3.737,7.864,7.864,0,0,0-5.867.694L353.188,546.5a9.158,9.158,0,0,0,.16-1.495,8.028,8.028,0,0,0-8-8.008H334.679a8,8,0,0,0-5.734,2.429l-6.8,7.475a2.638,2.638,0,0,1-1.894.774H316.01v5.339h4.241a8,8,0,0,0,5.734-2.429l6.8-7.475a2.638,2.638,0,0,1,1.894-.774h10.668a2.669,2.669,0,0,1,0,5.339h-5.334a2.669,2.669,0,0,0,0,5.339h10.668a2.457,2.457,0,0,0,.96-.187l18.669-7.287s.24-.107.373-.187a2.682,2.682,0,0,1,2.027-.267,2.639,2.639,0,0,1,1.627,1.255A2.675,2.675,0,0,1,373.35,550l-18.482,10.678a2.849,2.849,0,0,1-1.52.347H316.01v5.339h37.524a8.161,8.161,0,0,0,4-1.068l18.482-10.678a8.055,8.055,0,0,0,2.934-10.945Z",
    transform: "translate(-316.01 -507.69)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_260",
    "data-name": "Trazado 260",
    d: "M331.339,539.678A5.339,5.339,0,1,0,326,534.339,5.338,5.338,0,0,0,331.339,539.678Z",
    transform: "translate(-299.362 -520.992)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_261",
    "data-name": "Trazado 261",
    d: "M361.659,526H324.332A5.351,5.351,0,0,0,319,531.339v16.017a5.351,5.351,0,0,0,5.332,5.339h37.326a5.351,5.351,0,0,0,5.332-5.339V531.339A5.351,5.351,0,0,0,361.659,526ZM327,547.356a2.676,2.676,0,0,0-2.666-2.669V534.008A2.676,2.676,0,0,0,327,531.339h31.994a2.676,2.676,0,0,0,2.666,2.669v10.678a2.676,2.676,0,0,0-2.666,2.669Z",
    transform: "translate(-311.018 -526)",
    fill: "#00c1d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarDinero);
export default __webpack_public_path__ + "static/media/dar-dinero.0a01128faa6753193101ddcb1d6a34c2.svg";
export { ForwardRef as ReactComponent };